var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"userAccountMsg"},[_c('p',[_vm._v(" 尊敬的 "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_vm._v("，欢迎登录使用。"),_c('span',{staticClass:"loginOut",on:{"click":_vm.loginOut}},[_vm._v("退出登录")])])])}
var staticRenderFns = []

export { render, staticRenderFns }